export const ACTION_TYPES = {
  MULTI: "multi",
  MEALS: "meals",
  INGREDIENTS: "ingredients",
  ALLERGENS: "allergens",
};

export const initialState = {
  allergens: [],
  meals: [],
  ingredients: [],
  providers: [],
};

export default function reducer(state, action) {
  switch (action.type) {
    case ACTION_TYPES.INGREDIENTS:
      return { ...state, ingredients: action.ingredients };

    case ACTION_TYPES.MEALS:
      return { ...state, meals: action.meals };

    case ACTION_TYPES.ALLERGENS:
      return { ...state, allergens: action.allergens };

    case ACTION_TYPES.MULTI:
      return { ...state, ...action.payload };

    default:
      throw new Error();
  }
}
